import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AuthActions } from 'common/auth/actions';
import { AuthLocalStorageKeys } from 'common/auth/constants';
import { DEFAULT_PATH } from 'module/auth/login/login.utils';

/**
 * Watches localstorage keys to sync states between browser tabs e.g. auth states
 */
export function useBrowserTabSync() {
    const dispatch = useDispatch();

    useEffect(() => {
        const authListener = (event: StorageEvent) => {
            if (event.key === 'activeUser') {
                if (!event.newValue) {
                    dispatch(AuthActions.logoutRequest());

                    return;
                }
                if (event.newValue !== event.oldValue) {
                    localStorage.removeItem(AuthLocalStorageKeys.activeStudySite);
                    window.location.pathname = DEFAULT_PATH;

                    return;
                }
            }

            if (event.key === 'switchingUser') {
                dispatch(AuthActions.handleSwitchUser(event.newValue === 'true'));
            }
        };

        window.addEventListener('storage', authListener);

        return () => window.removeEventListener('storage', authListener);
    }, [dispatch]);
}
